<script setup lang="ts"></script>

<template>
  <icon name="lucide:download" />
</template>

<style scoped></style>
